export const monthlySeizures = [
  { month: 'মে', seized: 1180, released: 1040 },
  { month: 'জুন', seized: 1265, released: 1102 },
  { month: 'জুলাই', seized: 1342, released: 1210 },
  { month: 'আগস্ট', seized: 1298, released: 1235 },
  { month: 'সেপ্টেম্বর', seized: 1410, released: 1302 },
  { month: 'অক্টোবর', seized: 612, released: 540 },
];

export const monthlyCollection = [
  { month: 'মে', amount: 3120000, reconciled: 3050000 },
  { month: 'জুন', amount: 3380000, reconciled: 3310000 },
  { month: 'জুলাই', amount: 3610000, reconciled: 3540000 },
  { month: 'আগস্ট', amount: 3540000, reconciled: 3490000 },
  { month: 'সেপ্টেম্বর', amount: 3890000, reconciled: 3800000 },
  { month: 'অক্টোবর', amount: 1670000, reconciled: 1580000 },
];

export const categoryBaseline: Record<string, number> = {
  motorcycle: 2140, car: 1580, cng: 1320, microbus: 610, bus: 290, truck: 540, pickup: 470, other: 160,
};

export const reasonBaseline: Record<string, number> = {
  'বৈধ কাগজপত্র না থাকা': 2210,
  'ফিটনেস সনদ না থাকা / মেয়াদোত্তীর্ণ': 1380,
  'রেজিস্ট্রেশন সংক্রান্ত সমস্যা': 1120,
  'ডুপ্লিকেট নম্বরপ্লেটের সন্দেহ': 240,
  'ছোটখাটো দুর্ঘটনা': 420,
  'সড়ক অবরোধ': 960,
  'চালকের অসদাচরণ / সহিংসতা': 190,
  'যানবাহন চলাচলের অনুপযোগী': 510,
  'অন্যান্য অনুমোদিত কারণ': 80,
};

export const divisionBaseline: Record<string, number> = {
  'ট্রাফিক-রমনা বিভাগ': 920, 'ট্রাফিক-লালবাগ বিভাগ': 640, 'ট্রাফিক-মতিঝিল বিভাগ': 1010, 'ট্রাফিক-ওয়ারী বিভাগ': 870,
  'ট্রাফিক-তেজগাঁও বিভাগ': 1240, 'ট্রাফিক-মিরপুর বিভাগ': 1130, 'ট্রাফিক-গুলশান বিভাগ': 860, 'ট্রাফিক-উত্তরা বিভাগ': 740,
};

export const approvalDays = [
  { division: 'রমনা', days: 3.4 }, { division: 'লালবাগ', days: 4.1 }, { division: 'মতিঝিল', days: 3.8 }, { division: 'ওয়ারী', days: 4.6 },
  { division: 'তেজগাঁও', days: 2.9 }, { division: 'মিরপুর', days: 3.6 }, { division: 'গুলশান', days: 3.1 }, { division: 'উত্তরা', days: 3.9 },
];

export const agingBaseline = [
  { bucket: '০–৭ দিন', count: 142 },
  { bucket: '৮–১৫ দিন', count: 58 },
  { bucket: '১৬–৩০ দিন', count: 31 },
  { bucket: '৩১–৬০ দিন', count: 17 },
  { bucket: '৬০+ দিন', count: 9 },
];

export const stationBaseline: Record<string, number> = {
  'তেজগাঁও ডাম্পিং স্টেশন': 148, 'মিরপুর ডাম্পিং স্টেশন': 96, 'উত্তরা ডাম্পিং স্টেশন': 61, 'সায়েদাবাদ ডাম্পিং স্টেশন': 112,
};

export const KPI_BASE = {
  totalSeized: 7410,
  todayNew: 38,
  collected: 21245000,
  longPending: 26,
  todayReleased: 31,
};

export const wreckerActivity = [
  { id: 'WRK-07', operator: 'মোঃ সুমন মিয়া', pcr: 14, pickups: 13, delivered: 13, reprints: 1 },
  { id: 'WRK-03', operator: 'মোঃ কবির হোসেন', pcr: 11, pickups: 11, delivered: 10, reprints: 0 },
  { id: 'WRK-11', operator: 'মোঃ রুবেল মিয়া', pcr: 12, pickups: 12, delivered: 12, reprints: 2 },
  { id: 'WRK-14', operator: 'মোঃ হাসান আলী', pcr: 6, pickups: 6, delivered: 6, reprints: 0 },
  { id: 'WRK-19', operator: 'মোঃ মামুন হোসেন', pcr: 4, pickups: 4, delivered: 4, reprints: 0 },
];
